import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M0.0719281 21.312C0.0719281 22.632 1.22278 24 2.54146 24H21.7223C23.041 24 24 22.776 24 21.312C24 20.844 23.964 6.432 23.964 5.652C23.964 3.156 23.6284 2.4 19.1688 2.4V0H16.7712V2.4H7.19281V0H4.7952V2.4H2.3976C1.07892 2.4 0 3.48 0 4.8L0.0719281 21.312ZM21.5784 20.4C21.5784 21.06 21.039 21.6 20.3796 21.6H3.5964C2.93706 21.6 2.3976 21.06 2.3976 20.4V12H21.5784V20.4ZM21.5784 9.6H2.3976V5.964C2.3976 5.316 2.91309 4.8 3.56044 4.8H4.7952V7.2H7.19281V4.8H16.7832V7.2H19.1808V4.8H20.3796C21.039 4.8 21.5784 5.34 21.5784 6V9.6Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
